import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";

import CodeEditor, { SelectionText } from "@uiw/react-textarea-code-editor";

interface ArgsType {
    podId: string,
    podName: string
}

interface PodLogProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

PodLog.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function PodLog(props:PodLogProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [podLog, setPodLog] = useState("");

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);

    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                executeResult({successYn: true}, true, "");
            }
            
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(stepIndex === 0) {
            loadPodLog();
        }
    }, [stepIndex]);

    function executeResult(result, closeYn, infoMessage) {
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function loadPodLog() {
        requests.get(PLATFORM_URL.POD + '/' + props.args?.podId + '/log')
        .then((response) => {
            setPodLog(response.data.pod_log);
        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }


    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("POD_LOG_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("POD_NAME_TEXT")}
                            </Text>
                            <CustomTextInput 
                                key={1} 
                                width={570} height={36} 
                                value={props.args?.podName || ''}
                                type={"text"} 
                                activeYn={false} 
                                inputCb={(v)=>{}} 
                                warnYn={false} 
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                        <View style={style.rowTopAlignContainer}>
                            <TextArea 
                                key={4} 
                                width={770} 
                                height={800}
                                value={podLog||""} 
                                type={"text"} 
                                activeYn={false}
                                inputCb={(v)=>{}} 
                                warnYn={false} 
                                placeHolderText={t("")}
                            />
                        </View>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    columeData: {
        width: 550,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
        overflow: "scroll"
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 0,
    },
});